<template lang="html">
  <div class="listchat layout-page" :style="stylechat">
    <MenuLayout/>
    <v-layout row wrap justify-center align-center class="mt-1 pl-3 pr-3" @click="InputFocusCancel()">
      <v-col
        cols="2"
        justify="center"
        align="center"
        class="pa-0"
      >
      </v-col>
      <v-col
        cols="8"
        justify="center"
        align="center"
        class="pa-0"
      >
        <span class="tab-title">{{$t('LeftSide.header.chat')}}</span>
      </v-col>
      <v-col
        cols="2"
        justify="center"
        align="center"
        class="pt-1 pa-0"
        @click="openMenu()"
      >
        <!-- <v-icon>fa-solid fa-circle-plus</v-icon> -->
        <img :src="`${publicPath}/assets/img/icons/addx24.png`" alt="">
      </v-col>
    </v-layout>
    <v-divider class="mt-4 mb-2"></v-divider>
    <v-layout row wrap justify-start align-center class="pt-4 pl-5 pr-5 pb-5">
      <v-text-field
        ref="search"
        id="searchtext"
        v-model="search"
        :placeholder="$t('LeftSide.searching')"
        prepend-inner-icon="mdi-magnify"
        solo
        dense
        hide-details
        clearable
        class="pr-1"
        @focus="InputFocus($event)"
      ></v-text-field>
    </v-layout>
    <div class="layout-listchat">
      <v-overlay :value="progress" z-index="0" opacity="0">
        <v-progress-circular
          indeterminate
          size="64"
          color="#6e6e6e"
        ></v-progress-circular>
      </v-overlay>
      <vue-pull-refresh :on-refresh="onRefresh" :config="config">
        <v-list flat two-line>
          <v-list-item-group>
            <template v-for="(item, index) in FilterListchat">
              <v-list-item
                :key="`${index}-${item.tokenroom}`"
                @click="routePage(item, index)"
                v-touch="{
                  left: () => swipe('Left', index),
                  right: () => swipe('Right', index)
                }"
              >
                <v-list-item-action @click="updatePin(item, index)" v-if="swipe_state === 'Right' && swipe_index === index">
                  <v-row justify="center" align="center" :class="item.pin === 'true' ? 'bg-list-swipe-unpin' : 'bg-list-swipe-pin'">
                    <v-avatar size="40">
                      <v-icon class="icon-color-white" v-if="item.pin === 'true'">mdi-pin-off</v-icon>
                      <v-icon class="icon-color-white" v-else>mdi-pin</v-icon>
                    </v-avatar>
                  </v-row>
                </v-list-item-action>
                <v-list-item-action v-if="item.pin === 'true'">
                  <v-badge
                    avatar
                    overlap
                    bottom
                    offset-x="15"
                    offset-y="20"
                  >
                    <template v-slot:badge>
                      <v-avatar>
                        <v-img :src="`${publicPath}/assets/img/icons/pin@3x.png`"></v-img>
                      </v-avatar>
                    </template>

                    <v-avatar size="50">
                      <v-img v-if="item.picture" :src="item.picture" class="img-position"></v-img>
                      <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                      <img v-else-if="item.type === 'group'" :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position">
                      <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                      <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                    </v-avatar>
                  </v-badge>
                </v-list-item-action>
                <v-list-item-action v-else>
                  <v-avatar size="50">
                    <v-img v-if="item.picture" :src="item.picture" class="img-position"></v-img>
                    <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                    <img v-else-if="item.type === 'group'" :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position">
                    <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                    <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                  </v-avatar>
                </v-list-item-action>
                <!-- <v-list-item-avatar v-else>
                  <v-img v-if="item.picture" :src="item.picture" class="img-position"></v-img>
                  <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'group'" :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                  <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                </v-list-item-avatar> -->
                <v-list-item-content class="pt-0">
                  <v-list-item-title v-text="item.name" class="text-overflow pt-2">
                  </v-list-item-title>
                  <v-list-item-subtitle class="tab-title-status text-overflow">
                    <span class='fontselectchat' v-if="item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user'">
                      {{$t('LeftSide.chat.leftChat')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'message'" v-html="convertMsg(item.message)"></span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'sticker'">
                      {{$t('LeftSide.chat.sendSticker')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'file' || item.typeofmessage == 'password_file'">
                     {{$t('LeftSide.chat.sendFile')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'location'">
                      {{$t('LeftSide.chat.sendLocation')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'contact'">
                      {{$t('LeftSide.chat.sendContact')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'image'">
                      {{$t('LeftSide.chat.sendPicture')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'note'">
                      {{$t('LeftSide.chat.sendNote')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'video'">
                      {{$t('LeftSide.chat.sendVideo')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'mention_message'">
                      {{$t('LeftSide.chat.sendReply')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'albums_message'">
                      {{$t('LeftSide.chat.createAlbum')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'task_message'">
                      {{$t('LeftSide.chat.createTask')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action_task'">
                      {{$t('LeftSide.chat.createProject')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'unsend_message'">
                      <!-- ยกเลิกข้อความ -->
                      {{item.message}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'carousel'">
                      {{$t('LeftSide.chat.sendCarousel')}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'conference_msg'">
                      {{$t('LeftSide.chat.sendConference_msg')}}
                    </span>
                    <span class='fontselectchat text2' v-else-if="item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime'">
                      {{item.message}}
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'call'">
                      <div v-if="item.message === 'success'" class="text2">
                        <v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone fa-rotate-90</v-icon> {{$t('LeftSide.chat.call.time')}} {{secondsToHms(item.time_count)}}
                      </div>
                      <div v-else-if="item.message === 'decline' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.noResponse')}}
                      </div>
                      <div v-else-if="item.message === 'decline' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                      </div>
                      <div v-else-if="item.message === 'cancle' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                      </div>
                      <div v-else-if="item.message === 'cancle' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                      </div>
                      <div v-else-if="item.message === 'cancel' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                      </div>
                      <div v-else-if="item.message === 'cancel' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                      </div>
                    </span>
                    <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action'">
                      <div v-if="item.message === 'invite'" class="text2">
                        {{$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
                      </div>
                      <div v-else-if="item.message === 'kick'" class="text2">
                        <!-- {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม -->
                        {{$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
                      </div>
                      <div v-else-if="item.message === 'leave' && item.tokenuser === tokenuser">
                        {{$t('ChatSide.system.self.leftGroup')}}
                      </div>
                      <div v-else-if="item.message === 'leave' && item.tokenuser !== tokenuser" class="text2">
                        <!-- {{item.nickname}} ออกจากกลุ่ม -->
                        {{$t('ChatSide.system.other.leftGroup', { name: item.nickname} )}}
                      </div>
                      <div v-else-if="item.message === 'active' && item.tokenuser === tokenuser">
                        <!-- คุณเข้าร่วมกลุ่ม -->
                        {{$t('ChatSide.system.self.joinGroup')}}
                      </div>
                      <div v-else-if="item.message === 'active' && item.tokenuser !== tokenuser" class="text2">
                        <!-- {{item.nickname}} เข้าร่วมกลุ่ม -->
                        {{$t('ChatSide.system.other.joinGroup', { name: item.nickname} )}}
                      </div>
                    </span>
                    <span class='fontselectchat' v-else-if="item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message'">
                      <!-- เริ่มต้นการสนทนา -->
                      {{$t('LeftSide.chat.startChat')}}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="pb-2" v-if="item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user'">
                  <v-list-item-action-text class='fontselectchat' v-text="time(item.timestamp)"></v-list-item-action-text>
                  <v-badge
                    overlap
                    color="red"
                    offset-y="10"
                    offset-x="25"
                    content="+99"
                    v-if="parseInt(item.count_read) >= 100"
                  >
                  </v-badge>
                  <v-badge
                    overlap
                    color="red"
                    offset-y="10"
                    offset-x="20"
                    :content="item.count_read"
                    v-else-if="item.count_read != '' && parseInt(item.count_read) != 0 && item.message != ''"
                  >
                  </v-badge>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="index < FilterListchat.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </vue-pull-refresh>
    </div>
    <ListchatMenu :ListchatMenu="ListchatMenu" @closeListMenu="closeListMenu"/>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Momenttime, Encode, Decode } from '@/services'
import ListchatMenu from '@/components/ListchatMenu'
import MenuLayout from '@/views/MenuLayout'
var VuePullRefresh = require('vue-pull-refresh')
var _ =require('lodash')

export default {
  data() {
    return {
      focusKey: false,
      swipe_state: '',
      swipe_index: 0,
      publicPath: process.env.VUE_APP_BASE_PATH,
      config: {
        progress: false,
        errorLabel: '',
        startLabel: '',
        readyLabel: '',
        loadingLabel: '',
        pullDownHeight: 20
      },
      ListchatMenu: false,
      search: '',
      stylechat: {
        "--Listchat-HeaderColor": "white",
        "--Listchat-TabBackground": "white",
        "--Listchat-Icon": "gray",
        "--Listchat-IconActive": "#2662ae",
        "--Listchat-Background": "white",
        "--Listchat-FontSize": "18px",
        "--Listchat-FontColor": "back",
        "--Listchat-FontSize-Status": "16px",
        "--Listchat-FontSize-Msg": "12px",
        "--Listchat-FontColor-Msg": "#6e6e6e",
        "--Listchat-FontColor-Status": "grey",
        "--Listchat-Background-Input": "#E2E1E3",
        "--Listchat-Color-Button": "#EFF2FE",
        "--Listchat-FontColor-Button": "#2662ae"
      },
      listchat: [],
      data_user: {},
      tokenuser: '',
    }
  },
  components: {
    'vue-pull-refresh': VuePullRefresh,
    ListchatMenu,
    MenuLayout
  },
  computed: {
    FilterListchat () {
      if (this.search !== '' && this.search !== null) {
        return this.listchat.filter(post => {
          return post.nickname.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listchat
      }
    },
    ...sync('*')
  },
  created() {
    // console.log(this.themechat)
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    this.data_user = user_profile['account']['profile']
    this.tokenuser = this.data_user.tokenuser
    this.getListChat(this.data_user.tokenuser)
  },
  watch: {
    socketmessage (data) {
      // console.log(data)
      // console.log(data.message)
      // var _ = require('lodash')
      var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
      if (indexmsg !== -1) {
        this.listchat[indexmsg].is_active = 'true'
      }
      var message = data.message
      // if (data.typeofmessage !== 'message') {
      //   message = 'Send ' + data.typeofmessage
      // }
      if (data.tokenroom !== this.actionF && data.tokenuser !== this.data_user.tokenuser) {
        this.listchat[indexmsg].count_read = (parseInt(this.listchat[indexmsg].count_read) + 1).toString()
        this.count_read = this.count_read + 1
        var indexblock = []
        var indexmessage = []
        var indexactive = []
        indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
        indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
        indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
        var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
        var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
        var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
        var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
        this.count_read = count - (countblock + countmsg + countactive)
        // if (this.count_read > 0) {
        //   this.showcountread = true
        // } else {
        //   this.showcountread = false
        // }

      }
      if (indexmsg === 0) {
        this.listchat[0].message = message
        this.listchat[0].timestamp = data.timestamp
        this.listchat[0].nickname = data.nickname
        this.listchat[0].typeofmessage = data.typeofmessage
        this.listchat[0].time_count = data.time_count
        this.listchat[0].file_name = data.file_name
        this.listchat[0].tokenuser = data.tokenuser
      } else {
        var dataindex = this.listchat[indexmsg]
        dataindex.message = message
        dataindex.timestamp = data.timestamp
        dataindex.nickname = data.nickname
        dataindex.typeofmessage = data.typeofmessage
        dataindex.time_count = data.time_count
        dataindex.file_name = data.file_name
        dataindex.tokenuser = data.tokenuser
        _.pullAt(this.listchat, indexmsg) // ลบ listchat เดิม
        this.listchat.unshift(dataindex) // เพิ่ม lischat ใหม่เข้าไป
      }
      // เรียงแชทใหม่ กรณที่มีการ pin
      var listpin = []
      var linstunpin = []
      this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
      listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
      linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
      this.listchat = _.union(listpin, linstunpin)
    },
  },
  methods: {
    InputFocus (evt) {
      // console.log(evt)
      const inputField = document.querySelector("#searchtext");
      const virtualKeyboardDetected = ''
      var me = this
      inputField.addEventListener("focusin", () => {
          console.log("Virtual keyboard detected! focusin")
          me.focusKey = true
          // window.addEventListener("resize", virtualKeyboardDetected )
      })
      // inputField.addEventListener("focusout", () => {
      //     console.log("Virtual keyboard detected! focusout")
      //     me.focusKey = false
      //     window.removeEventListener("resize", virtualKeyboardDetected )
      // })
    },
    InputFocusCancel () {
      this.listchat = this.listchat
      this.focusKey = false
      const inputField = document.querySelector("#searchtext");
      const virtualKeyboardDetected = ''
      var me = this
      // inputField.addEventListener("focusin", () => {
      //     console.log("Virtual keyboard detected! focusin")
      //     me.focusKey = true
      //     window.addEventListener("resize", virtualKeyboardDetected )
      // })
      inputField.addEventListener("focusout", () => {
        console.log("Virtual keyboard detected! focusout")
        me.focusKey = false
        // window.removeEventListener("resize", virtualKeyboardDetected )
      })
      console.log('InputFocusCancel')

    },
    updatePin (item, index) {
      var key = ''
      if (item.pin === 'true') {
        key = 'false'
      } else {
        key = 'true'
      }
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/setpin', {
        tokenuser: this.tokenuser,
        tokenroom: item.tokenroom,
        pin: key
      }).then((response) => {
        if (response.data.status === 'success') {
          this.swipe_state = ''
          this.swipe_index = 0
          // pinchat
          this.listchat[index].pin = key
          var listpin = []
          var linstunpin = []
          this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
          listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          this.listchat = _.union(listpin, linstunpin)
          // console.log(this.listchat)
          // console.log('this.swipe_state: ', this.swipe_state)
          // console.log('this.swipe_index: ', this.swipe_index)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    swipe (direction, index) {
      this.swipe_state = direction
      this.swipe_index = index
      // console.log('swipe: ', direction)
      // console.log('swipe index: ', index)
    },
    secondsToHms (d) {
      d = Number(d)
      var hours = Math.floor(d / 3600)
      var minutes = Math.floor((d - (hours * 3600)) / 60)
      var seconds = d - (hours * 3600) - (minutes * 60)
      var time = ''

      if (hours !== 0) {
        time = hours + ':'
      }
      if (minutes !== 0 || time !== '') {
        minutes = (minutes < 10 && time !== '') ? '0' + minutes : String(minutes)
        time += minutes + ':'
      }
      if (time === '') {
        time = seconds + ' วินาที'
      } else {
        time += (seconds < 10) ? '0' + seconds : String(seconds)
      }
      return time
    },
    convertMsg (msg) {
      msg = msg.replace(/\<tax>/g,'<span style="color:#1976d2;">@');
      msg = msg.replace(/<\/tax>/g,'</span>');
      // console.log(msg)
      return msg
    },
    getListChat (tokenuser) {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_GO + `/v4/getListChat`, {
        tokenuser: tokenuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.listchat = response.data['listchat']
          // pinchat
          var listpin = []
          var linstunpin = []
          this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true'})
          listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          this.listchat = _.union(listpin, linstunpin)
          // count_read
          var indexblock = []
          var indexmessage = []
          var indexactive = []
          indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
          indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
          indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
          var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
          var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
          var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
          var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
          this.count_read = count - (countblock + countmsg + countactive)
          // console.log('this.count_read: ', this.count_read)
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.listchat = []
      })
    },
    closeListMenu () {
      this.ListchatMenu = false
    },
    openMenu () {
      this.ListchatMenu = true
    },
    onRefresh () {
      // console.log('refresh')
      var me = this
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          me.getListChat(me.data_user.tokenuser)
          resolve();
        }, 1000);
      });
    },
    routePage (item, index) {
      if (this.swipe_state === 'Right' && this.swipe_index === index) {
        this.swipe_state = ''
        this.swipe_index = 0
      } else {
        this.search = null
        // this.InputFocusCancel()
        const inputField = document.querySelector("#searchtext");
        const virtualKeyboardDetected = ''
        var me = this
        inputField.addEventListener("focusout", () => {
          console.log("Virtual keyboard detected! focusout")
        })
        // this.listchat = this.listchat
        // this.focusKey = false
        var me = this
        if (item.type === 'bot') {
          setTimeout(function() {
            me.getConsent(item.tokenuser, item.tokenroom)
          }, 1000);
        } else {
          setTimeout(function() {
            me.$router.push(`/chat/${item.tokenroom}`)
          }, 1000);
        }
        var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === item.tokenroom })
        this.listchat[indexmsg].is_active = 'true'
        this.listchat[indexmsg].count_read = 0
        this.mark_read(item)
      }
    },
    getConsent (botid, tokenroom) {
      this.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v1/get-consent-bot', {
        tokenuser: this.data_user.tokenuser,
        bot_id: botid
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.isConsent === true && response.data.isAccept === false) {
            var dataConsent = Encode.encode(response.data.data)
            this.$router.push('/check-consent/' + tokenroom + `/?data_consent=${dataConsent}`)
          } else {
            this.$router.push('/chat/' + tokenroom)
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    mark_read (data) {
      // console.log(data)
      if (data.count_read !== '0' && data.count_read !== '') {
        this.axios.post(process.env.VUE_APP_API_alpine + '/v1/user-mark-read', {tokenuser: this.data_user.tokenuser, tokenroom: data.tokenroom}).then((response) => {
        })
      }
    },
    time (timestamp) {
      if (this.$i18n.locale == 'th') {
        return Momenttime.dayjstimethaiformnow(timestamp)
      } else if (this.$i18n.locale == 'cn') {
        return Momenttime.dayjstimethaiformnowcn(timestamp)
      } else {
        return Momenttime.dayjstimethaiformnowen(timestamp)
      }
      // return Momenttime.dayjstimethaiformnow(timestamp)
    },
  }
}
</script>

<style lang="css" scoped>
.icon-color-white {
  color: white !important;
}
.bg-list-swipe-unpin {
  background-color: var(--Listchat-IconActive) !important;
  height: 82px !important;
  width: 65px !important;
}
.bg-list-swipe-pin {
  /* background-color: white !important; */
  background-color: var(--Listchat-IconActive) !important;
  height: 82px !important;
  width: 65px !important;
  padding: 0 !important;
}
.fontselectchat {
  font-size: var(--Listchat-FontSize-Msg) !important;
  color: var(--Listchat-FontColor-Msg) !important;
}
.layout-listchat-focus {
  height: calc(100vh - 490px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.layout-listchat-focus::-webkit-scrollbar {
  width: 4px;
}

.layout-listchat-focus::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
.layout-listchat {
  height: calc(100vh - 170px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.layout-listchat::-webkit-scrollbar {
  width: 4px;
}

.layout-listchat::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
>>>.pull-down-container {
  /* padding: 0px !important; */
  /* overflow-y: hidden !important; */
  height: unset !important;
  max-height: unset !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}
>>>.pull-down-container::-webkit-scrollbar {
  height: 10px;
  width: 0px;
}
>>>.pull-down-header {
  width: 100%;
  height: 0px;
  overflow: hidden;
  position: relative;
  background-color: var(--Listchat-Background) !important;
}
>>>.pull-down-content {
  position: absolute;
  max-width: 90%;
  bottom: 10px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  height: 40px;
  color: #0054ad;
  text-align: center;
  border-left: 20px solid transparent;
  font-family: "noto-thin", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
}
.tab-title {
  color: var(--Listchat-FontColor) !important;
  font-size: var(--Listchat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--Listchat-FontColor-Status) !important;
  font-size: var(--Listchat-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
>>>.v-input__slot {
  background-color: var(--Listchat-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
.tab-title {
  color: var(--Listchat-FontColor) !important;
  font-size: var(--Listchat-FontSize) !important;
  font-weight: 600;
}
.layout-page {
  height: calc(100vh - 64px) !important;
  overflow: hidden !important;
  background-color: var(--Listchat-Background) !important;
}
</style>
